import React from "react";
import s from "./style.module.css";

const Content = ({ items }) => {
  return (
    <div className={s.content}>
      {items.map(({ Component, props }, i) => (
        <Component {...props} key={i} />
      ))}
    </div>
  );
};

export default Content;
